export const pic_width = 300;
export const pic_height = pic_width * 0.75;
